import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  gridContainer: {
    padding: theme.spacing(4, 3, 4),
    backgroundColor: theme.screens.login.SingleCardAccess.backgroundColor,
    alignItems: 'center',
    maxWidth: '410px',
    borderRadius: '4px',
    border: `1px solid ${theme.screens.login.SingleCardAccess.border}`,

    [theme.breakpoints.down('xs')]: {
      maxWidth: '336px',
      padding: theme.spacing(5, 2, 5),
    },
  },
  title: {
    fontFamily: theme.typography.bancoDoBrasilTextos.fontFamily,
    fontSize: theme.screens.login.SingleCardAccess.title.fontSize,
    fontWeight: '700',
    lineHeight: '16px',
    color: theme.screens.login.SingleCardAccess.title.color,
    textAlign: 'center',
  },
  marginTitleC: {
    marginBottom: '11px',

    [theme.breakpoints.down('xs')]: {
      marginBottom: '16px',
    },
  },
  marginTitleNC: {
    marginTop: '24px',
    marginBottom: '16px',

    [theme.breakpoints.down('xs')]: {
      marginTop: '16px',
    },
  },
  marginTitleWL: {
    marginBottom: '16px',
  },
  btnText: {
    fontFamily: theme.typography.bancoDoBrasilTitulos.fontFamily,
    fontSize: theme.screens.login.SingleCardAccess.btnText.fontSize,
    lineHeight: '19px',
    color: theme.screens.login.SingleCardAccess.btnText.color,
    textTransform: 'none',
    textAlign: 'center',
    whiteSpace: 'pre-wrap',

    [theme.breakpoints.down('xs')]: {
      fontSize: '17px',
    },
  },
  marginBtnTextNC: {
    marginBottom: '28px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '15px',
    },
  },
  marginBtnTextWL: {
    marginBottom: '28px',
    [theme.breakpoints.down('xs')]: {
      marginBottom: '34px',
      fontSize: '14px',
    },
  },
  description: () => ({
    fontFamily: theme.typography.bancoDoBrasilTextos.fontFamily,
    fontSize: '16px',
    lineHeight: '18px',
    color: theme.appColors.darkGray,
    textAlign: 'center',
    letterSpacing: 0,
    margin: theme.spacing(7, 0),
    padding: theme.spacing(0, 3),
  }),
  btnAcessar: {
    width: '100%',
    maxWidth: '330px',
    height: '56px',
    borderRadius: '4px',
    padding: theme.spacing(1),
    marginTop: '30px',
    marginBottom: theme.spacing(3),

    [theme.breakpoints.down('xs')]: {
      maxWidth: '272px',
      marginTop: '24px',
      marginBottom: '16px',
    },
  },
  btnAcessarText: {
    width: '100%',
    fontFamily: theme.typography.inter.fontFamily,
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: '46px',
    color: theme.appColors.primaryColor,
  },
  icon: {
    width: 39,
    height: 39,
    marginRight: '12px',
  },
  link: {
    fontFamily: theme.typography.inter.fontFamily,
    fontSize: '13px',
    fontWeight: 500,
    lineHeight: '15px',
    color: theme.screens.login.SingleCardAccess.link,
    textDecoration: 'underline',
    textUnderlineOffset: '3px',
    cursor: 'pointer',
    marginTop: '16px',
    [theme.breakpoints.down('xs')]: {
      marginTop: '32px',
    },
  },
}));
